import { createApi } from '@core/api/base-api';
import { auth } from '@core/utils/firebase/firebase';
import type { Auth } from '@angular/fire/auth';
import type { User as ApiUser } from '@core/interfaces/api';

// Use strong typing from generated API
export type UserProfile = ApiUser;

export const createAuthApi = (firebaseAuth: Auth) => {
  const api = createApi(firebaseAuth);

  return {
    // This is the CMS, so ask for the CMS membership explicitly. A Firebase
    // identity can also own a mobile (participant) row; without `platform=cms`
    // the API returns the lowest-id row, which for a dual-role identity is the
    // older mobile row (GD-7).
    getUserByFirebaseUid: (uid: string): Promise<UserProfile> =>
      api.get<UserProfile>(`/user/firebase/${uid}?platform=cms`),
  };
};

// module-level instance for convenience
export const authApi = createAuthApi(auth as unknown as Auth);
